import { getPassengerInfo } from '../../services/airSearch/airSearchRequest/helpers'
import { getAirportCityName } from '../../util/crossSellGenericAd'

export const buildPackageSearchHeaderProps = ({ searchRequest, bundleComponents }) => {
  const { slices, params } = searchRequest
  const { adults, childAges } = getPassengerInfo({ params })

  const startDate = slices[0].travelDate
  const endDate = slices[slices.length - 1].travelDate

  const flyComponent = bundleComponents.find((component) => component.type === 'FLY')
  const { origin, destination } = flyComponent?.query || {}

  const originCityName = origin?.type === 'CITY' ? origin.name : null
  const destinationCityName = destination?.type === 'CITY' ? destination.name : null

  const originAirport = slices[0].originAirport
  const destinationAirport = slices[0].destinationAirport

  // If origin and destination city names are present in flyComponent,
  // then use those names instead of airport city names
  const originDisplayName = originCityName || getAirportCityName(originAirport, { searchRequest })
  const destinationDisplayName =
    destinationCityName || getAirportCityName(destinationAirport, { searchRequest })

  const YOUTH_AGE = 12
  const childAgesArray = childAges ? childAges.split(',').map((age) => Number(age)) : []
  const youths = childAgesArray.filter((age) => age >= YOUTH_AGE).length

  return {
    search: {
      adults: adults - youths,
      children: childAgesArray.length,
      origin: {
        displayName: originDisplayName,
      },
      destination: {
        displayName: destinationDisplayName,
      },
      startDate,
      endDate,
      isOneWayFlight: slices.length === 1,
      childAges: childAgesArray,
    },
    hasHotelInSearch: false,
    hasFlightInSearch: true,
  }
}
